export default __webpack_public_path__ + "static/media/instagram-logo.f570cea0.svg";